/**
 * author:Bry
 * Data:2023-04-17 13:55
 * des:故障管理js
 */


import config from "@/config";
import http from "@/utils/request";

export default {
    lgSosAlert: {
        url: `${config.MAIN_URL}/api/v1/lgSosAlert`,
        name: "sos分页查询",
        get: async function (params) {
            return await http.get(this.url, params);
        },
        delete: async function (params) {
            return await http.delete(this.url+ params);
        },
    },
    byIdInfo: {
        url: `${config.MAIN_URL}/api/v1/lgSosAlert/byId`,
        name: "通过ID查询单条数据",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    polling: {
        url: `${config.MAIN_URL}/api/v1/lgSosAlert/polling`,
        name: "轮询告警",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    largeScreen: {
        url: `${config.MAIN_URL}/api/v1/lgSosAlert/largeScreen`,
        name: "大屏统计",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    SOSLargeScreen: {
        url: `${config.MAIN_URL}/api/v1/lgSosAlert/SOSLargeScreen`,
        name: "大屏-SOS报警记录列表",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    LargeScreenById: {
        url: `${config.MAIN_URL}/api/v1/lgSosAlert/LargeScreenById`,
        name: "大屏-通过ID查询单条数据",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    executeList: {
        url: `${config.MAIN_URL}/api/v1/lgSosAlert/executeList`,
        name: "执行列表",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    dutySchedulepage: {
        url: `${config.MAIN_URL}/api/v1/dutySchedule/page`,
        name: "分页查询值班数据",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    setTheResponseLevel: {
        url: `${config.MAIN_URL}/api/v1/lgSosAlert/setTheResponseLevel`,
        name: "接受和拒绝",
        put: async function (params) {
            return await http.put(this.url, params);
        },
    },
    sosexecute: {
        url: `${config.MAIN_URL}/api/v1/lgSosAlert/execute`,
        name: "执行",
        put: async function (params) {
            return await http.put(this.url, params);
        },
    },
    geoTown: {
        url: `${config.MAIN_URL}/api/v1/geoTown`,
        name: "查询所有镇",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    geoVillage: {
        url: `${config.MAIN_URL}/api/v1/geoVillage`,
        name: "根据镇ID查询村信息",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    sandTablepage: {
        url: `${config.MAIN_URL}/api/v1/sandTable/page`,
        name: "查询所有镇",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    dutyScheduletoday: {
        url: `${config.MAIN_URL}/api/v1/dutySchedule/today`,
        name: "获取值班人信息",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    sandTabletype: {
        url: `${config.MAIN_URL}/api/v1/sandTable/type`,
        name: "获取沙盘类型列表",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    sandTabletlist: {
        url: `${config.MAIN_URL}/api/v1/sandTable/list`,
        name: "获取全部沙盘列表",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    getlingaoweather: {
        url: `${config.MAIN_URL}/api/v1/realweather/getlingaoweather`,
        name: "获取临高天气",
        get: async function (params) {
            return await http.get(this.url, params);
        },
    },
    dutySchedule: {
        url: `${config.MAIN_URL}/api/v1/dutySchedule`,
        name: "新增值班数据",
        post: async function (params) {
            return await http.post(this.url, params);
        },
        put: async function (params) {
            return await http.put(this.url, params);
        },
        delete: async function (params) {
            return await http.delete(this.url+ params);
        },
    },
    sandTableInfo: {
        url: `${config.MAIN_URL}/api/v1/sandTable`,
        name: "根据ID查询沙盘详情",
        get: async function (params) {
            return await http.get(this.url, params);
        },
        put: async function (params) {
            return await http.put(this.url, params);
        },
        delete: async function (params) {
            return await http.delete(this.url+ params);
        },
    },
};
